<template>
  <div
    :class="[
      'BaseSelect',
      { 'valid':   !invalid },
      { 'invalid': invalid },
      { 'dirty':   dirty },
      { 'empty':   !value },
      { ghost },
    ]">

    <h6
      class="_label pb-1"
      v-if="label"
      v-text="label">
    </h6>

    <BaseDropdown
      ref="DropdownComponent"
      match-width
      :persist-label="false"
      :anchor="anchor"
      @open="optionsFocused = true">
      <template
        #label>
        <div
          class="_field">
          <input
            class="_input"
            ref="input"
            type="button"
            readonly="readonly"
            :placeholder="placeholder"
            :value="computedDisplayValue"
            :required="required"
            :disabled="disabled"
            :autofocus="autofocus"
            @focus="$emit('focus')"
            @blur="$emit('blur', $event)"
          />
          <i
            class="_icon icon-dropdown">
          </i>
        </div>
      </template>

      <template
        #dropdown>
        <BaseSelectOptions
          :options="options"
          :selected="selectedOption"
          :focused="optionsFocused"
          @select="handleOptionSelect"
          @blur="handleOptionsBlur"
        />
      </template>
    </BaseDropdown>
  </div>
</template>

<script>
import BaseSelectOptions from '@/components/BaseSelectOptions.vue';
import BaseDropdown from '@/components/BaseDropdown.vue';

export default {
  name: 'BaseSelect',

  components: {
    BaseDropdown,
    BaseSelectOptions,
  },

  data() {
    return {
      optionsFocused: false,
    };
  },

  props: {
    ghost:       { type: Boolean, default: false },
    options:     { type: Array,   required: true },
    anchor:      { type: String,  default: 'left' },
    value:       { type: String,  default: '' },
    focused:     { type: Boolean, default: false },
    dirty:       { type: Boolean, default: false },
    invalid:     { type: Boolean, default: false },
    placeholder: { type: String,  default: 'Select' },
    label:       { type: String,  default: '' },
    required:    { type: Boolean, default: false },
    disabled:    { type: Boolean, default: false },
    autofocus:   { type: Boolean, default: false },
  },

  computed: {
    computedDisplayValue() {
      if (!this.value) return this.placeholder;
      return this.selectedOption.label;
    },

    selectedOption() {
      return this.options.find((o) => o.value === this.value) || null;
    },

  },

  watch: {
    focused(focused) {
      if (focused) this.$refs.input.focus();
    },
  },

  methods: {
    handleOptionSelect(option) {
      this.$emit('input', option.value);
      this.$refs.DropdownComponent.closeDropdown();
    },

    // handleOptionsBlur(e) {
    //   if (e.relatedTarget && e.relatedTarget.parentElement === e.target) {
    //     e.preventDefault();
    //     return;
    //   }
    //   this.optionsFocused = false;
    //   setTimeout(() => {
    //     this.$refs.DropdownComponent.closeDropdown();
    //   }, 200);
    // },

    handleOptionsBlur() {
      this.optionsFocused = false;
      setTimeout(() => {
        if (this.$refs.DropdownComponent) {
          this.$refs.DropdownComponent.closeDropdown();
        }
      }, 100);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/_variables';

.BaseSelect {
  text-align: left;
}

.BaseSelect ._label {
  letter-spacing: 0.5px;
}

.BaseSelect ._field {
  position: relative;
}

.BaseSelect ._input {
  display: block;
  width: 100%;
  height: 38px;
  padding-left: 12px;
  padding-right: 34px;
  text-align: left;
  font-size: 14px;
  font-weight: inherit;
  text-transform: inherit;
  color: inherit;
  border: $border;
  border-radius: $radius;
  background: $white;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  cursor: pointer;
  transition: border .3s ease 0s;
}

.BaseSelect.ghost ._input {
  background: transparent;
  border: none;
}

.BaseSelect.dirty.invalid ._input {
  border-color: $red;
}

._icon {
  position: absolute;
  top: 4px;
  right: 6px;
  color: darken($grey, 10%);
  font-size: 28px;
  pointer-events: none;
}
</style>
